import React from 'react';
import { useMCContext } from '../contexts/useMCStates';
import { Box, Tooltip, Stack, Typography } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

interface UserRegisteredProps {
    eventID: string;
    position: 'absolute' | 'relative' | 'inline';
    width?: number;
    /** When true, only the icon is shown (no "Registered" text) on all platforms */
    iconOnly?: boolean;
}

export const UserRegistered = ({eventID, position, width, iconOnly}: UserRegisteredProps) => {

    const { userRegistrations, factor, windowSize } = useMCContext();
    const isInline = position === 'inline';
    const showLabel = !iconOnly && windowSize.isMobile && !width;

    return (
        userRegistrations.some((registration: any) => registration.eventID === eventID) && 
            <Box sx={{ 
                position: isInline ? 'relative' : position, 
                zIndex: isInline ? 0 : 1000,
                display: 'flex',
                alignItems: 'center',
            }}>
                <Tooltip 
                    title="You are registered for this event"
                    placement='bottom-start'
                    PopperProps={{
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, 10],
                                },
                            },
                        ],
                    }}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                fontSize: `${1*factor}rem`,
                                padding: `${0.5*factor}px ${1*factor}px`,
                            }
                        }
                    }}
                >
                    <Box sx={{ 
                        position: isInline ? 'relative' : position, 
                        zIndex: isInline ? 0 : 1000, 
                        left: isInline ? 0 : (width ? 0 : -10), 
                        top: isInline ? 0 : (width ? 0 : -10), 
                        width: width ? width*factor : undefined, 
                        height: width ? width*factor : undefined, 
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0,
                    }}>
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <TaskAltIcon sx={{ color: 'success.main', fontSize: (iconOnly && width) ? `${width * factor}px` : (isInline ? `${1.25*factor}rem` : `${1.5*factor}rem`) }} />
                            {showLabel && (
                                <Typography variant='caption' sx={{ fontWeight: 500, color: 'success.main' }}>
                                    Registered
                                </Typography>
                            )}
                        </Stack>
                    </Box>
                </Tooltip>
            </Box>
    )
}
